module.exports = __webpack_public_path__ + "img/main.81ab3869.png";